import { Flex } from "antd";
import "./LoanDetails.scss";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../../../assets/helpers";

const LoanDetails = ({ data }) => {
  const { format } = useSelector(state => state.priceFormat);

  const personalDetails = [
    {
      label: "Customer Mailing Address-1",
      value: data?.cust_mailing_addr1 || 'NA',
    },
    { label: "Customer Mailing Address-2", value: data?.cust_mailing_addr2 || 'NA' },
    { label: "Customer Mailing Address-3", value: data?.cust_mailing_addr3 || 'NA' },
    { label: "Customer Mailing Address-4", value: data?.cust_mailing_addr4 || 'NA' },
    { label: "Customer Mailing City", value: data?.cust_mailing_city || 'NA' },
    { label: "Phone Number-2", value: data?.cust_mailing_phone2 || 'NA' },
    { label: "Mobile Number", value: data?.cust_mailing_phone1 || "NA" },
    { label: "Last Due Date", value: data?.last_due_date ? moment(data?.last_due_date).format('DD-MM-YYYY') : 'NA' },
    {
      label: "Address-1",
      value: data?.address_1 || 'NA',
    },
    {
      label: "Address-2",
      value: data?.address_2 || 'NA',
    },
  ];

  const loanDetails = [
    { label: "Loan No", value: data?.loan_no || 'NA' },
    { label: "Loan EMI", value: data?.loan_emi || 'NA' },
    { label: "Total Amount Due", value: formatCurrency(data?.amount_overdue, format) },
    { label: "Bounce Charges", value: formatCurrency(data?.bounce_charges, format) },
    { label: "Other Charges", value: formatCurrency(data?.other_charges, format) },
    { label: "DPD", value: data?.dpd || "NA" },
    { label: "Bucket", value: data?.bucket || "NA" },
    { label: "Disbursal Date", value: data?.disbursal_date ? moment(data?.disbursal_date).format('DD-MM-YYYY') : 'NA' },
    { label: "Disbursal Amount", value: formatCurrency(data?.disbursal_amount, format) },
    { label: "Bounce Reason", value: data?.bounce_reason || 'NA' },
    {
      label: "Bounce Date", value: data?.bounce_date
        ? moment(data?.bounce_date
        ).format('DD-MM-YYYY') : 'NA'
    },
    {
      label: "Due Date", value: data?.due_date
        ? moment(data?.due_date
        ).format('DD-MM-YYYY') : 'NA'
    },
    { label: "EMI Start Date", value: data?.emi_start_date ? moment(data?.emi_start_date).format('DD-MM-YYYY') : 'NA' },
    { label: "Link Account-1", value: data?.link_acct_1 || 'NA' },
    { label: "Link Account-2", value: data?.link_acct_2 || 'NA' },
    { label: "Link Account-3", value: data?.link_acct_3 || 'NA' },
    { label: "Link Account-4", value: data?.link_acct_4 || 'NA' },
    { label: "Link Account-5", value: data?.link_acct_5 || 'NA' },
    { label: "Last Contacted Date", value: data?.last_contacted_date ? moment(data?.last_contacted_date).format('DD-MM-YYYY') : 'NA' },
    { label: "Last Contacted On", value: data?.last_contacted_on ? moment(data?.last_contacted_on).format('DD-MM-YYYY') : 'NA' },
    { label: "Broken Settlement", value: data?.broken_settlement || 'NA' },
    { label: "Settlement Rejected", value: data?.sett_rejected || "NA" },
    { label: "Settlement Approved", value: data?.sett_approved_nil_pyt || 'NA' },
  ];

  const assetDetails = [
    { label: "Asset Description", value: data?.asset_desc || 'NA' },
    { label: "Customer Model", value: data?.model || 'NA' },
    { label: "Engine Number", value: data?.engine_no || 'NA' },
    { label: "Chasis Number", value: data?.chassis_no || 'NA' },
    { label: "Tenure", value: data?.tenure || 'NA' },
    { label: "Disbursal Date", value: data?.disbursal_date ? moment(data?.disbursal_date).format('DD-MM-YYYY') : 'NA' },
  ];

  return (
    <Flex className="loanDetails-container">
      {/* PERSONAL DETAILS */}
      <Flex className="personall-details-wrapper">
        <h2 className="heading">Personal Details</h2>
        <Flex className="personal-details-container">
          {personalDetails.map((item, idx) => (
            <Flex className="personal-details-wrapper" key={idx}>
              <p className="details-label">{item.label}</p>
              <p className="details-value">{item.value}</p>
            </Flex>
          ))}
        </Flex>
      </Flex>

      {/* LOAN DETAILS */}
      <Flex className="loan-details-wrapper">
        <h2 className="heading">Loan Details</h2>
        <Flex className="personal-details-container">
          {loanDetails.map((item, idx) => (
            <Flex className="personal-details-wrapper" key={idx}>
              <p className="details-label">{item.label}</p>
              <p className="details-value">{item.value}</p>
            </Flex>
          ))}
        </Flex>
      </Flex>

      {/* ASSET DETAILS */}
      <Flex className="assets-details-wrapper">
        <h2 className="heading">Asset Details</h2>
        <Flex className="personal-details-container">
          {assetDetails.map((item, idx) => (
            <Flex className="personal-details-wrapper" key={idx}>
              <p className="details-label">{item.label}</p>
              <p className="details-value">{item.value}</p>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default LoanDetails;
